export class UserProfileModel {
    firstName: string;
    lastName: string;
    email: string;
    nationalId: string;
    birthDate: Date;
    birthdate: Date;
    isMale: boolean;
    directoryId: number;
    educationLevel:string;
    occupationField:string;
    usageField:string;
    isPasswordLoginEnabled:boolean=true;
    isAddNewUserAllowed:boolean;
    userStatus:number;
    get isMaleStr(): string {
        return this.isMale ? "True" : "False";
    }

    set isMaleStr(value: string) {
        this.isMale = value === "True" ? true : false;
    }
}